export default "__VITE_ASSET__BWxjmRTh__"